// Predefined label sizes (in millimeters) and paper types

export const LABEL_SIZE_PRESETS = [
  { key: "40x20", label: "40 x 20 mm", widthMm: 40, heightMm: 20 },
  { key: "50x30", label: "50 x 30 mm", widthMm: 50, heightMm: 30 },
  { key: "60x40", label: "60 x 40 mm", widthMm: 60, heightMm: 40 },
  { key: "70x50", label: "70 x 50 mm", widthMm: 70, heightMm: 50 },
  { key: "80x60", label: "80 x 60 mm", widthMm: 80, heightMm: 60 },
  { key: "100x70", label: "100 x 70 mm", widthMm: 100, heightMm: 70 },
  { key: "100x100", label: "100 x 100 mm", widthMm: 100, heightMm: 100 },
  { key: "a4sheet", label: "A4 Sticker Sheet", widthMm: 210, heightMm: 297 },
  { key: "thermalroll", label: "Thermal Roll (58mm)", widthMm: 58, heightMm: 40 },
  { key: "custom", label: "Custom Size", widthMm: 60, heightMm: 40 },
];

export const PAPER_TYPES = [
  { value: "INDIVIDUAL_STICKER", label: "Individual Sticker" },
  { value: "ROLL_STICKER", label: "Roll Sticker" },
  { value: "A4_SHEET", label: "A4 Sticker Sheet" },
  { value: "THERMAL", label: "Thermal Printer Labels" },
  { value: "CONTINUOUS_ROLL", label: "Continuous Roll" },
  { value: "CUSTOM", label: "Custom Paper" },
];

export const BARCODE_TYPES = [
  { value: "CODE128", label: "Code128" },
  { value: "EAN13", label: "EAN13" },
  { value: "UPC", label: "UPC" },
  { value: "QR", label: "QR Code" },
  { value: "CUSTOM", label: "Custom Barcode" },
];

// mm to px conversion at a fixed working DPI used across designer + preview + PDF
export const MM_TO_PX = 96 / 25.4;

export const mmToPx = (mm) => mm * MM_TO_PX;
export const pxToMm = (px) => px / MM_TO_PX;
